<template>
  <component :is="layout" />
</template>

<script>
import signals from '@/signals'
import EmptyLayout from './layouts/EmptyLayout'
import MainLayout from './layouts/MainLayout'

export default {
  name: 'App',

  watch: {
    dark: function () {
      this.switchScrollColors()
    }
  },

  computed: {
    layout() {
      return (this.$route.meta.layout || 'empty') + '-layout'
    },

    dark() {
      return this.$vuetify.theme.dark
    }
  },

  created() {
    // Загрузка справочников не дожидаясь логинов
    this.$store.dispatch('prefetch')
  },

  mounted() {
    this.switchScrollColors()
  },

  methods: {
    switchScrollColors() {
      document.getElementsByTagName('body')[0].classList = this.dark ? 'darkScrollbar' : ''
    }
  },

  components: {
    EmptyLayout,
    MainLayout,
    signals
  }
}
</script>

<style>
.styled-table th {
  font-weight: 500 !important;
  text-transform: uppercase !important;
}

/* курсор в таблице - палец */
.pointed-table tbody tr {
  cursor: pointer;
}

.pointed-table tbody tr.v-data-table__expanded__content {
  cursor: auto;
}

/* выпилил мерзкий белый цвет, режуший глаза */
#app .theme--dark.v-data-table,
#app .theme--dark.v-icon,
#app .theme--dark.v-footer {
  color: #e0e0e0;
}

/* отдельно для пунктов меню выпилил мерзкий белый цвет, режуший глаза */
#app .theme--dark.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: #dcdcdc !important;
}

/* отдельно более яркий  */
#app .theme--dark.v-pagination,
#app .theme--dark.v-pagination .v-pagination__item,
#app .theme--dark.v-pagination .v-pagination__item--active,
#app .theme--dark.v-list {
  color: #fff;
}

/* убрать скрытый инпут из v-select - vuetify bug */
.v-select-shrinked input {
  display: none;
}

/* убрать сраную прозрачность tooltip */
.v-tooltip__content.menuable__content__active {
  opacity: 1 !important;
}
</style>

<style lang="scss">
.darkScrollbar {
  &::-webkit-scrollbar {
    width: 13px;
    height: 13px;
  }

  /*кнопки вверх/вниз*/
  &::-webkit-scrollbar-button {
    width: 13px;
    height: 13px;
    background-color: #3e3e42;

    &:vertical:start:decrement {
      background-image: url(./assets/scroll_up.png);
    }

    &:vertical:start:decrement:hover {
      background-image: url(./assets/scroll_up_active.png);
    }

    &:vertical:end:increment {
      background-image: url(./assets/scroll_down.png);
    }

    &:vertical:end:increment:hover {
      background-image: url(./assets/scroll_down_active.png);
    }
  }

  /*track*/
  &::-webkit-scrollbar-track {
    background-color: #3e3e42;
  }

  /*ползунок*/
  &::-webkit-scrollbar-thumb {
    background-color: #686868;

    &:hover {
      background-color: #9e9e9e;
    }
  }

  .v-navigation-drawer--expand-on-hover:hover .v-list {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: calc(100vh - 64px);
    /* Adjust based on your header height */
  }

  /* Better approach with a specific class */
  .compact-menu-overflow .v-list {
    overflow-y: auto !important;
    overflow-x: hidden !important;
  }
}
</style>
